
import { ButtonEvent } from "slotworks/graphics/elements/button-element";
import Layers from "slotworks/graphics/layers/layers";
import SettingsModel from "slotworks/model/settings/settings-model";
import AbstractButtonBehaviour from "slotworks/smart-button/behaviours/abstract-button-behaviour";
import StateMachine from "slotworks/state-machine/state-machine";
import autoplayModel from "slotworks/model/autoplay-model";

export default class SkipButtonBehaviour extends AbstractButtonBehaviour {

    public init() {
        Layers.SmartButton.setScene("skip").execute();
        this.button = Layers.SmartButton.getFlexiButton("next");

        this.button.on(ButtonEvent.POINTER_DOWN, this.onDownListener);

        document.addEventListener("keyup", this.onKeyUpListener);

        const autoButton = Layers.SmartButton.getFlexiButton("auto_start_disabled");
        if (autoButton) {
            autoButton.setEnabled(false);
            if(autoplayModel.autoplayDisabled) {
                autoButton.setVisible(false);
            }
        }

        const autospinButton = Layers.SmartButton.getFlexiButton("autospin");
        if (autospinButton) {
            autospinButton.setEnabled(false);
            if(autoplayModel.autoplayDisabled) {
                autospinButton.setVisible(false);
            }
        }

        const quickSpinToggle = Layers.SmartButton.getFlexiToggle("quickspin");
        if(quickSpinToggle) {
            if(SettingsModel.isQuickSpinDisabled()) {
                quickSpinToggle.setEnabled(false);
                quickSpinToggle.setVisible(false);
            } else {
                quickSpinToggle.setVisible(true);
                quickSpinToggle.setValue(SettingsModel.getQuickSpin());
                quickSpinToggle.setEnabled(false);
            }
        }
    }

    public destroy() {
        this.button.off(ButtonEvent.POINTER_DOWN, this.onDownListener);

        document.removeEventListener("keyup", this.onKeyUpListener);

        super.destroy();
    }

    private onKeyUpListener = (event: any) => {
        if (SettingsModel.getSpaceToSpin()) {
            if (event.keyCode === 32) {
                this.onDownListener();
            }
        }
    }

    private onDownListener = () => {
        StateMachine.skip();
    }
}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/smart-button/behaviours/skip-button-behaviour.ts